import React, { Component } from 'react';

type Props = {
  str: string;
}

export interface State {
  str: string;
}

class DisplayString extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    let str = props.str.trim();
    // debugger;
    // while(str.includes("\n\n")) {
    //   str = str.replace("\n\n", "\n");
    // }
    while(str.includes("\n")) {
      str = str.replace("\n","<br/>");
    }
    while(str.includes(" <br/>")) {
      str = str.replace(" <br/>","<br/>");
    }
    while(str.includes("<table><br/>")) {
      str = str.replace("<table><br/>","<table>");
    }
    while(str.includes("<tbody><br/>")) {
      str = str.replace("<tbody><br/>","<tbody>");
    }
    while(str.includes("<thead><br/>")) {
      str = str.replace("<thead><br/>","<thead>");
    }
    while(str.includes("<tr><br/>")) {
      str = str.replace("<tr><br/>","<tr>");
    }
    while(str.includes("<th><br/>")) {
      str = str.replace("<th><br/>","<th>");
    }
    while(str.includes("<td><br/>")) {
      str = str.replace("<td><br/>","<td>");
    }
    // while(str.includes("</table><br/>")) {
    //   str = str.replace("</table><br/>","</table>");
    // }
    while(str.includes("</tbody><br/>")) {
      str = str.replace("</tbody><br/>","</tbody>");
    }
    while(str.includes("</thead><br/>")) {
      str = str.replace("</thead><br/>","</thead>");
    }
    while(str.includes("</tr><br/>")) {
      str = str.replace("</tr><br/>","</tr>");
    }
    while(str.includes("</th><br/>")) {
      str = str.replace("</th><br/>","</th>");
    }
    while(str.includes("</td><br/>")) {
      str = str.replace("</td><br/>","</td>");
    }
    while(str.includes("/n")) {
      str = str.replace("/n","");
    }
    this.state = {
      str
    };
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (prevProps.str !== this.props.str) {
      let str = this.props.str.trim();
      // debugger;
      // while(str.includes("\n\n")) {
      //   str = str.replace("\n\n", "\n");
      // }
      while(str.includes("\n")) {
        str = str.replace("\n","<br/>");
      }
      while(str.includes("<table><br/>")) {
        str = str.replace("<table><br/>","<table>");
      }
      while(str.includes("<tbody><br/>")) {
        str = str.replace("<tbody><br/>","<tbody>");
      }
      while(str.includes("<thead><br/>")) {
        str = str.replace("<thead><br/>","<thead>");
      }
      while(str.includes("<tr><br/>")) {
        str = str.replace("<tr><br/>","<tr>");
      }
      while(str.includes("<th><br/>")) {
        str = str.replace("<th><br/>","<th>");
      }
      while(str.includes("<td><br/>")) {
        str = str.replace("<td><br/>","<td>");
      }
      // while(str.includes("</table><br/>")) {
      //   str = str.replace("</table><br/>","</table>");
      // }
      while(str.includes("</tbody><br/>")) {
        str = str.replace("</tbody><br/>","</tbody>");
      }
      while(str.includes("</thead><br/>")) {
        str = str.replace("</thead><br/>","</thead>");
      }
      while(str.includes("</tr><br/>")) {
        str = str.replace("</tr><br/>","</tr>");
      }
      while(str.includes("</th><br/>")) {
        str = str.replace("</th><br/>","</th>");
      }
      while(str.includes("</td><br/>")) {
        str = str.replace("</td><br/>","</td>");
      }
      while(str.includes("/n")) {
        str = str.replace("/n","");
      }
      this.setState({ str });
    }
  }

  componentDidMount() {
  }

  render() {
    // console.log(this.state.str);
    return (
      <span dangerouslySetInnerHTML={{ __html: this.state.str }}></span>
    )
  }
}

export default DisplayString;
